import cookie from 'react-cookie';

// Name of the first-party cookie set by Cello Attribution.js when a user
// lands on the site via a referral link. Verify against the live cookie if
// the Cello Attribution script is updated.
export const CELLO_REFERRAL_COOKIE_NAME = 'cello-referral';

/**
 * Cello referral / tracking id from first-party attribution cookie, if present.
 *
 * @returns {string|null}
 */
export function getCelloReferralTrackingId() {
  try {
    const raw = cookie.load(CELLO_REFERRAL_COOKIE_NAME);
    if (raw == null) {
      return null;
    }
    const s = String(raw).trim();
    return s.length > 0 ? s : null;
  } catch (e) {
    return null;
  }
}

export function hasCelloReferralCookie() {
  return getCelloReferralTrackingId() != null;
}

/**
 * Fetches Cello new-user reward eligibility for the logged-in user (Twine user id = productUserId).
 * Proxies GET /new-users/{productUserId}/reward — see Twine API users/{id}/cello/new-user-reward.
 *
 * Only hits the API when `cello-referral` is set (Cello attribution cookie); avoids unnecessary Cello calls.
 *
 * @param {string|number|null|undefined} userId
 * @returns {Promise<boolean>}
 */
export function fetchCelloNewUserRewardEligible(userId) {
  if (userId == null || userId === '') {
    return Promise.resolve(false);
  }
  if (!getCelloReferralTrackingId()) {
    return Promise.resolve(false);
  }
  const id = String(userId).trim();
  if (id === '' || typeof fetch === 'undefined') {
    return Promise.resolve(false);
  }
  return fetch(`/api/users/${encodeURIComponent(id)}/cello/new-user-reward`, {
    credentials: 'same-origin',
  })
    .then((res) => {
      if (!res.ok) {
        return false;
      }
      return res.json().then((body) => Boolean(body && body.eligible));
    })
    .catch(() => false);
}
